<template>
  <div id="tag-sider">
    <Author />
    <a-divider>
      <a-icon type="tags" style="margin-right:.3rem" />标签
    </a-divider>
    <div class="tags">
      <template v-for="(tag,index) in tags">
        <router-link
          :to="{name:'tag',params:{tagId:tag.tagId,tagName:tag.name}}"
          :key="'tags'+index"
        >
          <a-tag :color="$route.params.tagId == tag.tagId?'#108ee9':''">{{tag.name}}</a-tag>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Author from "./sider/Author";
import serverPath from "../serverPath";
export default {
  name: "tag-sider",
  data() {
    return {
      tags: []
    };
  },
  computed: {
    ...mapState(["articleTotal", "total"])
  },
  components: {
    Author
  },
  methods: {
    getTags() {
      this.axios({
        url: serverPath.getTags,
        methods: "get"
      })
        .then(res => {
          if (res.status === 200) {
            this.tags = res.data;
          }
        })
        .catch(err => {
          this.$message.error("获取标签信息失败：" + err);
        });
    }
  },
  mounted() {
    this.getTags();
  }
};
</script>

<style lang="scss" scoped>
.tags {
  padding: 0.3rem 0.5rem;
  .ant-tag {
    margin: 0.3rem;
  }
}
</style>